import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import CreatePostForm from "./PostForm";
import CreateIcon from "../../Icons/CreateIcon";
import { createPostSchema, IPostSchema } from "../../utils/validationSchema";
import { yupResolver } from "@hookform/resolvers/yup";

const EditPost = (props: any) => {
  const { handleEdit, isLoading, data } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IPostSchema>({
    defaultValues: async () => ({
      headline: data?.headline,
      content: data?.content,
      author: data?.author,
      category: data?.category.map((cat) => ({
        label: cat.name,
        value: cat.id,
      })),
      tag: data?.tag.map((ta) => ({
        label: ta.name,
        value: ta.id,
      })),
      preview_image: data?.preview_image,
      table_of_content: data?.table_of_content,
    }),
    resolver: yupResolver(createPostSchema),
  });

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Post</span>
      </div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <CreatePostForm
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          control={control}
          data={data}
        />
      </FormLayout>
    </>
  );
};

export default EditPost;
